import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import CustomAxios from "../../../utility/customAxios";
import { AttendanceStatus } from "../../../types/Event";
import { Dictionary } from "lodash";
import { Nullable } from "../../../types/utils";

export type UseGetEventsAttendanceProps = {
  uuids: string[];
  employeeUuid: string;
  enabled?: boolean;
};

export type EventAttendance = Nullable<{
  status: AttendanceStatus;
  checked_in_at: string;
  checked_out_at: string;
}>;

export type EventsAttendanceResponse = Dictionary<EventAttendance>;

const fetchEventsAttendance = async (uuids: string[], employeeUuid: string) => {
  const response = await CustomAxios.post<EventsAttendanceResponse>(`events/attendance`, {
    uuids,
    employee_uuid: employeeUuid,
  });
  const { data } = response;
  return data;
};

export function useGetEventsAttendance({
  uuids,
  employeeUuid,
  enabled = true,
}: UseGetEventsAttendanceProps) {
  const query = useQuery({
    enabled: enabled && uuids.length > 0,
    queryKey: [queryKeys.eventAttendance, employeeUuid, uuids],
    queryFn: () => fetchEventsAttendance(uuids, employeeUuid),
    placeholderData: keepPreviousData,
  });
  return query;
}
